import React, { useEffect } from 'react';
import { useAuthGate } from '../hooks/useAuthGate';
import { AuthGateContext } from './AuthGateContext';

export function AuthGateProvider({ children, limit = 2, scope = 'global' }) {
  const gate = useAuthGate({ limit, scope });
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handler = (event) => {
      const reason = event?.detail?.reason;
      if (reason === 'guest_quota_exceeded' && gate?.setJoinOpen) {
        if (gate?.setReason) gate.setReason(reason);
        gate.setJoinOpen(true);
        return;
      }
      if (gate?.guard) {
        if (gate?.setReason) gate.setReason(null);
        gate.guard('guest_quota')();
      }
    };
    window.addEventListener('auth-gate:open', handler);
    return () => window.removeEventListener('auth-gate:open', handler);
  }, [gate]);
  return <AuthGateContext.Provider value={gate}>{children}</AuthGateContext.Provider>;
}

export default AuthGateProvider;
